export default __webpack_public_path__ + "static/media/hihome_logo_beta.a012378f.png";